import { observer } from "mobx-react-lite";
import { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Context } from "..";
import Placeholder from "./Placeholder";
import { fix2026Periods } from "../store/store";

const Header = () => {
  const { store } = useContext(Context);
  const [isLoading, setIsLoading] = useState(true);
  const [showNavbar, setShowNavbar] = useState(false);

  async function handleFixClick() {
    try {
      const res = await fix2026Periods();
      alert("Периоды 2026 года успешно обновлены до 24 дней!");

      localStorage.setItem("fix2026_done", "true");
    } catch (err) {
      alert("Ошибка при обновлении: ");
    }
  }

  useEffect(() => {
    async function checkAuthentication() {
      if (localStorage.getItem("token")) {
        try {
          await store.checkAuth();
        } catch (e) {
          console.log(e);
        }
      }
      setIsLoading(false);
    }

    checkAuthentication();
  }, [store]);

  if (isLoading) {
    return <Placeholder />;
  }

  return (
    <header>
      <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            Программа отпусков
          </a>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setShowNavbar((prev) => !prev)} // 👈 Toggle вручную
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            id="mainNavbar"
            className={`collapse navbar-collapse d-sm-inline-flex justify-content-between ${
              showNavbar ? "show" : ""
            }`}
          >
            <ul className="navbar-nav flex-grow-1">
              <li className="nav-item">
                <Link to="/" className="nav-link text-dark">
                  Главная
                </Link>
              </li>
              {store.user.roles?.[0] === "ADMIN" && (
                <>
                  <li className="nav-item">
                    <Link to="/users" className="nav-link text-dark">
                      Список сотрудников
                    </Link>
                  </li>
                  {/* <li className="nav-item ms-3">
                      <Button variant="danger" onClick={handleFixClick}>
                        Обновить периоды 2026 года
                      </Button>
                    </li> */}
                  <li className="nav-item">
                    <Link to="/controlGroups" className="nav-link text-dark">
                      Контрольные группы
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/positions" className="nav-link text-dark">
                      Должности
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/departments" className="nav-link text-dark">
                      Отделы
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/stateHolidays" className="nav-link text-dark">
                      Гос.праздники
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/home/generalTable"
                      className="nav-link text-dark"
                    >
                      Общая таблица
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/users/createUsers"
                      className="nav-link text-dark"
                    >
                      Создать сотрудника
                    </Link>
                  </li>
                </>
              )}
              {store.user.isLeader && (
                <li className="nav-item">
                  <Link
                    to={`/departments/${store.user.department._id}`}
                    className="nav-link text-dark"
                  >
                    Мой отдел
                  </Link>
                </li>
              )}
            </ul>

            <ul className="navbar-nav flex-grow-1 justify-content-end align-items-center">
              <li className="nav-item">
                {store.isAuth ? (
                  <Link
                    to={`/profile/${store.user.id}`}
                    className="nav-link text-dark"
                  >
                    Личный кабинет
                  </Link>
                ) : (
                  <a className="nav-link text-dark" href="/login">
                    Войти
                  </a>
                )}
              </li>
              {store.isAuth && (
                <li className="nav-item">
                  <Button
                    className="btn-sm btn-dark"
                    onClick={() => store.logout()}
                  >
                    Выход
                  </Button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default observer(Header);
